<template>
	<!--底部 start-->
	<div class="footer"><div class="mainBody"><div class="left"><div class="t1">执考网</div><div class="t2"><a href="https://www.chuy1.com/#video">执考网官网</a><a href="https://www.chuy1.com/html/about/#video">关于我们</a><a href="https://www.yizhengwx.com/html/about/lianxi/#video">联系我们</a></div><div class="t3"><span><img src="../assets/footer_phone1.png" alt="">咨询热线：400-101-6156</span><span><img src="../assets/footer_phone1.png" alt="">合作电话：400-996-7761</span></div><a class="t4" href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2021042361号-1</a></div><div class="right"><div class="t1"><div class="down"><img src="/ios_xiazai1.png" alt=""></div><div class="down"><img src="/anzhuo_xiazai1.png" alt=""></div></div></div></div></div></div>
	<!--底部 end-->
</template>

<script>
	export default {
		name: 'Footer',

	}
</script>
 

<style>
	.footer .botInfoBox .textBox .webInfo a {
		
		font-size: 14px;
		color: #fff;
	}
	.footer {
		background: #fff;
		padding: 20px 0;
	}
.footer .mainBody {
    display: flex;
    justify-content: space-between;
}
.mainBody {
    width: 1200px;
    margin: 0 auto;
}
.footer .mainBody .left {
    font-size: 14px;
}
.footer .mainBody .left .t2 {
    line-height: 46px;
}
.footer .mainBody .left .t3 {
    display: flex;
    margin-bottom: 15px;
}
.footer .mainBody .left .t2 a {
    margin-right: 40px;
}
.footer .mainBody .left .t3 span {
    display: flex;
    align-items: center;
    margin-right: 40px;
}
.footer .mainBody .left .t3 span img {
    margin-right: 8px;
}
	.footer .linkBox {
		height: 36px;
		padding: 24px 0;
		border-bottom: 1px solid #525252;
	}

	.footer .linkBox .linkLogo {
		width: 117px;
		height: 36px;
		border-right: 1px dashed #3e3e3e;
		background-position: -175px -100px;
	}

	.footer .linkBox .linkList {
		width: 1000px;
		height: 30px;
		overflow: hidden;
	}

	.footer .linkBox .linkList a {
		font-size: 15px;
		color: #ffffff;
		margin-left: 20px;
		line-height: 36px;
		white-space: nowrap;
	}

	.footer .botInfoBox {
		display: flex;
		justify-content:space-around;
		padding-top: 45px;
	}

	.footer .botInfoBox .textBox {
		width: 370px;
		height: 160px;
	}

	.footer .botInfoBox .textBox .nav {
		font-size: 18px;
		color: #fff;
	}

	.footer .botInfoBox .textBox .nav a {
		font-size: 18px;
		color: #ffffff;
	}

	.footer .botInfoBox .textBox .add {
		padding-top: 15px;
		font-size: 15px;
		color: #fff;
		opacity: .3;
		line-height: 1.6em;
	}

	.footer .botInfoBox .textBox .webInfo {
		padding-top: 15px;
		font-size: 15px;
		color: #fff;
		opacity: .3;
		line-height: 1.6em;
	}

	.footer .botInfoBox .textBox .webInfo a {
		font-size: 15px;
		color: #fff;
	}

	.footer .botInfoBox .phone {
	/* 	padding-top: 44px;
		height: 44px; */
		 
	}

	.footer .botInfoBox .phone .icon {
		float: left;
	}

	.footer .botInfoBox .phone .icon i {
		display: inline-block;
		width: 44px;
		height: 44px;
		background-position: -10px -145px;
	}

	.footer .botInfoBox .phone .phoneNum {
		float: left;
		margin-left: 5px;
	}

	.footer .botInfoBox .phone .phoneNum h3 {
		font-size: 14px;
		color: #fff;
		margin-top: -8px;
	}

	.footer .botInfoBox .phone .phoneNum p {
		font-size: 28px;
		color: #ffffff;
	}

	.footer .botInfoBox .codeBox {
		text-align: center;
	}

	.footer .botInfoBox .codeBox img {
		width: 98px;
		height: 98px;
	}

	.footer .botInfoBox .codeBox h3 {
		font-size: 14px;
		color: #fff;
		opacity: .3;
		padding-top: 12px;
	}
</style>
